import { TaskDocumentationState } from '@dokucoach/common-types';

export function isPostponedOrDeviated(state: TaskDocumentationState): boolean {
  switch (state) {
    case TaskDocumentationState.DEVIATION:
    case TaskDocumentationState.POSTPONED:
    case TaskDocumentationState.POSTPONEDSCHEDULED:
      return true;
    default:
      return false;
  }
}
